// A new deploy replaces hashed chunk filenames on the CDN. A tab left open
// across a deploy (or a lazy route visited for the first time after one)
// tries to fetch a chunk that no longer exists and throws "Failed to fetch
// dynamically imported module". The fix is a one-time hard reload to pick up
// the current index.html/asset manifest; the sessionStorage guard stops a
// reload loop if the failure is actually persistent (offline, CDN outage).
const CHUNK_RELOAD_KEY = 'advoltix:chunk-reload-attempted';

const CHUNK_ERROR_PATTERN =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;

export function isChunkLoadError(message: string): boolean {
  return CHUNK_ERROR_PATTERN.test(message);
}

export function reloadOnStaleChunk(): void {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
  sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  window.location.reload();
}

/** Call once at boot so a real future deploy can still trigger a reload. */
export function clearChunkReloadGuardSoon(delayMs = 15000): void {
  window.setTimeout(() => sessionStorage.removeItem(CHUNK_RELOAD_KEY), delayMs);
}
